module.exports = __webpack_public_path__ + "img/zip-lines-2.5ac1e40b.jpg";